/**
 * Aligns with API `MaterialRequestStatus`.
 * After `APPROVED` (and typically after submit), treat payloads as immutable — new cycles via new requests/issues per domain doc.
 */
export enum MaterialRequestStatus {
  REQUESTED = "REQUESTED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
}

export const MaterialRequestStatusMap: Record<
  string,
  { label: string; color: string }
> = {
  [MaterialRequestStatus.REQUESTED]: {
    label: "Requested",
    color: "warning",
  },
  [MaterialRequestStatus.APPROVED]: {
    label: "Approved",
    color: "success",
  },
  [MaterialRequestStatus.REJECTED]: {
    label: "Rejected",
    color: "danger",
  },
  [MaterialRequestStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
  },
  [MaterialRequestStatus.COMPLETED]: {
    label: "Completed",
    color: "primary",
  },
};

/** API `MaterialRequestSourceType`. */
export const MaterialRequestSourceType = {
  WORK_ORDER: "WORK_ORDER",
  PETTY_WORK: "PETTY_WORK",
} as const;

export type MaterialRequestSourceTypeValue =
  (typeof MaterialRequestSourceType)[keyof typeof MaterialRequestSourceType];

export const MaterialRequestSourceTypeLabel: Record<
  MaterialRequestSourceTypeValue,
  string
> = {
  [MaterialRequestSourceType.WORK_ORDER]: "Work order",
  [MaterialRequestSourceType.PETTY_WORK]: "Petty work",
};

/**
 * Sent as `sourceType` on create from job forms (subset; same string values as API).
 */
export const MaterialRequestFormSource = {
  PETTY_WORK: MaterialRequestSourceType.PETTY_WORK,
  WORK_ORDER: MaterialRequestSourceType.WORK_ORDER,
} as const;
